"use strict";

var HelpMixin, React;

React = require("react");

HelpMixin = {
  propTypes: {
    dataKey: React.PropTypes.string.isRequired,
    helpText: React.PropTypes.string
  },
  helpSpan: function helpSpan() {
    var helpView;
    if (this.props.helpText) {
      return helpView = React.createElement(
        "span",
        { className: "help-block margin-top-sm" },
        this.props.helpText
      );
    }
  }
};

module.exports = HelpMixin;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/mixins/Help.js
 ** module id = 285
 ** module chunks = 0
 **/